export const EMPRESAS_PERMISSIONS = {
  dashboardRead: 'companies.read',
  companyCreate: 'companies.create',
  companyUpdate: 'companies.update',
  companyDelete: 'companies.delete',
  clientManage: 'customers.manage',
  leadManage: 'leads.manage',
  contractManage: 'contracts.manage',
  quoteManage: 'quotes.manage',
  saleManage: 'sales.manage',
} as const;
